module.exports = __webpack_public_path__ + "img/yyjjfa_03.bf62dc4e.jpg";